/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {checkRewardCode} from '../api'

export const useMutationCheckRewardCode = createReactQueryMutationHook('checkRewardCode', checkRewardCode)
